import './src/styles/global.css';
import React, { useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { ScrollProvider } from "./src/context/ScrollContext";

export const wrapPageElement = ({ element, props }) => {
  const { location } = props;


  return <AnimatePresence mode="wait">{element}</AnimatePresence>;
};

export const wrapRootElement = ({ element }) => (
  <ScrollProvider>{element}</ScrollProvider>
);
